import { render, staticRenderFns } from "./caixasItens.vue?vue&type=template&id=15375a2e"
import script from "./caixasItens.vue?vue&type=script&lang=js"
export * from "./caixasItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports